import HelperComponent from 'components/Tour/HelperComponent';
import { getDropDownStep } from 'components/Tour/_dropDownStep';
import { useReactTour } from 'components/Tour/useReactTour';
import { useTranslation } from 'react-i18next';
export const TourUserTagStatistics = () => {
  const { t } = useTranslation('Reactour');

  const allSteps = ({ isDropDownOpen }: any) => {
    const steps = {
      '[data-tour="userTagForm"]': t('statisticsByUserTag.form'),
      ...getDropDownStep({ isDropDownOpen, t }),
      '[data-tour="search-header-searchForm-clearButton"]': t('searchList.clearButton'),
      '[data-tour="search-header-searchForm-searchButton"]': t('searchList.searchButton'),
      '[data-tour="user-tag-statistic-result-grid"]': t('statisticsByUserTag.grid'),
      '[data-tour="common-gridColumns"]': t('common.gridColumns'),
      '[data-tour="common-gridFilters"]': t('common.gridFilters'),
    };
    return steps;
  };

  useReactTour({ stepsDefinition: allSteps });

  return <HelperComponent smallSize={true} />;
};
